// src/pages/AdminProdutos/ProdutoItemAdmin.js
import React from 'react';
import './ProdutoItemAdmin.css';

function ProdutoItemAdmin({ produto, onEdit, onToggleAtivoPDV, onDelete }) {
  return (
    <div className="produto-item-admin">
      <h4>{produto.nome}</h4>
      <p>ID: {produto.id}</p>
      <p>Ativo no PDV: <span className={produto.ativoPDV ? 'ativo-sim' : 'ativo-nao'}>{produto.ativoPDV ? 'Sim' : 'Não'}</span></p>

      <h5>Opções:</h5>
      <ul>
        {produto.opcoes.map((opcao, index) => (
          <li key={index}>
            Tamanho: {opcao.tamanho}, Preço: R$ {opcao.preco.toFixed(2)}
            {opcao.adicionaisDisponiveis && opcao.adicionaisDisponiveis.length > 0 && (
              <span className="adicionais-list">
                {' '}Adicionais: {opcao.adicionaisDisponiveis.map(add => add.nome).join(', ')}
              </span>
            )}
          </li>
        ))}
      </ul>

      <div className="item-actions">
        <button className="edit-btn" onClick={onEdit}>Editar</button>
        <button
          className={produto.ativoPDV ? 'toggle-off-btn' : 'toggle-on-btn'}
          onClick={() => onToggleAtivoPDV(produto.id, produto.ativoPDV)}
        >
          {produto.ativoPDV ? 'Desativar no PDV' : 'Ativar no PDV'}
        </button>
        <button className="delete-btn" onClick={() => onDelete(produto.id)}>Deletar</button>
      </div>
    </div>
  );
}

export default ProdutoItemAdmin;